export default __webpack_public_path__ + "static/media/avatar_8.485d8309.png";